export default "__VITE_ASSET__DRq$l0H___"